import EventClass from "common/utils/ui/event-class";

export default class DtfUploadManager extends EventClass {
  #activeUploadTileId = null;

  #allTileInstances = new Set();

  constructor() {
    super({});
  }

  registerTile(tileInstance) {
    this.#allTileInstances.add(tileInstance);
  }

  unregisterTile(tileInstance) {
    this.#allTileInstances.delete(tileInstance);
  }

  isUploadActive(tileId = null) {
    if (tileId) {
      return this.#activeUploadTileId !== null && this.#activeUploadTileId !== tileId;
    }
    return this.#activeUploadTileId !== null;
  }

  setActiveUpload(tileId) {
    this.#activeUploadTileId = tileId;
    this.#disableAllOtherTiles(tileId);
  }

  clearActiveUpload() {
    this.#activeUploadTileId = null;
    this.#enableAllTiles();
  }

  #disableAllOtherTiles(activeTileId) {
    this.#allTileInstances.forEach(instance => {
      if (instance.tileId !== activeTileId) {
        instance.setDisabled(true);
      }
    });
  }

  #enableAllTiles() {
    this.#allTileInstances.forEach(instance => {
      instance.setDisabled(false);
    });
  }
}
